import { render, staticRenderFns } from "./previewModal.vue?vue&type=template&id=36e1f46a&scoped=true"
import script from "./previewModal.vue?vue&type=script&lang=ts"
export * from "./previewModal.vue?vue&type=script&lang=ts"
import style0 from "./previewModal.vue?vue&type=style&index=0&id=36e1f46a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e1f46a",
  null
  
)

export default component.exports